import { Link, UntranslatedLink, ResourceList, UntranslatedResourceList, UntranslatedResourceNavItem, ResourceNavItem } from '../models/Navigation'
import { LanguageString } from '../models/Language'

const translateLink = (untranslatedLink: UntranslatedLink, lang: LanguageString): Link => {
  const { labels, hrefs, ...link } = untranslatedLink
  const href = hrefs[lang]
  const label = labels[lang]
  return { href, ...link, label }
}

export const translateResourceList = (untranslatedResourceList: UntranslatedResourceList, lang: LanguageString): ResourceList => {
  const { descriptions, labels, ...resourceList } = untranslatedResourceList

  const label = labels[lang]
  const description = descriptions ? descriptions[lang] : undefined
  const links = resourceList.links.map((link) => translateLink(link, lang))

  return { ...resourceList, links, label, description }
}

export const translateResourceNavItem = (untranslatedResourceNavItem: UntranslatedResourceNavItem, lang: LanguageString): ResourceNavItem => {
  const { labels, subsections, ...partialResourceNavItem } = untranslatedResourceNavItem

  const label: string = labels[lang]
  const translatedSubsections: ResourceList[] = subsections.map(list => translateResourceList(list, lang))

  return { ...partialResourceNavItem, label, subsections: translatedSubsections }
}
